import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

const PERFORMANCE_DATASETS_DOC = 'performanceDatasets';
const CURRENT_PERFORMANCE_DATASETS_VERSION = 'v1';

const wizardSateConverter = {
  toFirestore(
    wizardState: PerformanceConfiguration.WizardState,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...wizardState, isValid: false });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): PerformanceConfiguration.WizardState {
    const data = {
      ...snapshot.data(options),
      isValid: false,
    };
    return data as PerformanceConfiguration.WizardState;
  },
};

const getPerformanceDatasetsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.SAVED_PROGRESSES_COLLECTION)
    .doc(PERFORMANCE_DATASETS_DOC)
    .collection(CURRENT_PERFORMANCE_DATASETS_VERSION)
    .withConverter(wizardSateConverter);
};

export default getPerformanceDatasetsRef;
